export default __webpack_public_path__ + "static/media/confirm (1).a935e0eb.png";